import PropTypes from 'prop-types';
import Input from "components/form/Input/Input";
import { useRef, useState } from "react";
import useData from "hooks/useData";
import Loader from "components/ui/Loader/Loader";
import Alert from "components/ui/Alert/Alert";
import Button from "components/ui/Button/Button";
import "components/form/Autocomplete/Autocomplete.scss";

const Autocomplete = ({ endpoint, value, placeholder, onSelect, onRenderResult }) => {
  const { getData } = useData();
  const [ search, setSearch ] = useState('');
  const [ loading, setLoading ] = useState();
  const [ results, setResults ] = useState([]);
  const [ selected, setSelected ] = useState(value);
  const [ error, setError ] = useState();
  const timeoutRef = useRef();

  const performSearch = async (search) => {
    setError();
    setLoading(true);

    const { data } = await getData(endpoint, `search=${ search }`);
    if (data) {
      setResults(data.search_results);
    } else {
      setResults(null);
      setError(`Het is momenteel niet mogelijk om te zoeken, probeer het later opnieuw. (${ data?.status })`);
    }

    setLoading(false);
  }

  const handleChangeSearch = (event) => {
    const value = event.target.value;
    setSearch(() => value);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (value.length >= 3) {
      timeoutRef.current = setTimeout(() => performSearch(value), 250);
    }
  }

  const handleClickChange = () => {
    handleSelectResult(null);
    setSearch('');
    setResults([]);
  }

  const handleSelectResult = (result) => {
    setSelected(result);
    onSelect(result);
  }

  return (
    <form className={ `autocomplete` }>
      {
        selected
          ?
          <div className={ `autocomplete__selected` }>
            <div className={ `autocomplete__selected-value` }>{ onRenderResult(selected, true) }</div>
            <Button variant={ `ghost` } onClick={ handleClickChange }>Wijzigen</Button>
          </div>
          :
          <Input type={ `text` }
                 value={ search }
                 onChange={ handleChangeSearch }
                 placeholder={ placeholder }
                 autoComplete={ `off` }/>
      }
      {
        error &&
        <Alert title={ `Fout` } message={ error }/>
      }
      {
        loading &&
        <Loader containerVariant={ 'center' } loaderVariant={ 'small' }/>
      }
      {
        results && results.length > 0 && !selected && !loading &&
        <div className={ `autocomplete__results` }>
          {
            results.map(
              (result, index) => {
                const rendered = onRenderResult(result);
                return (
                  <div key={ index } className={ `autocomplete__result` } onClick={ () => handleSelectResult(result) }>
                    { rendered }
                  </div>
                );
              }
            )
          }
        </div>
      }
      {
        !error && !results &&
        <div className={ `autocomplete__results` }>
          <div className={ `autocomplete__result` }>Geen resultaten gevonden</div>
        </div>
      }
    </form>
  )
}

Autocomplete.propTypes = {
  endpoint: PropTypes.string.isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onRenderResult: PropTypes.func.isRequired,
}

export default Autocomplete;
